import {
  Box,
  Button,
  Flex,
  Input,
  useColorModeValue,
} from "@chakra-ui/react";
import React from "react";
import { useDispatch } from "react-redux";
import { filters } from "../../data";
import { actions } from "../../redux/slice";
import { DateFilterTypeEnum } from "../../types";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css"; // Make sure you import this
import Card from "../../../../../components/card/Card";
import { useTranslation } from "react-i18next";

interface Props {
  filterValue: DateFilterTypeEnum;
  startDate: string | Date;
  endDate: string | Date;
}

const Filter: React.FC<Props> = ({ filterValue, endDate, startDate }) => {
  const today = new Date();
   const { t } = useTranslation();
  const dispatch = useDispatch();
  const textColor = useColorModeValue("brand.500", "white");
  const secondary = useColorModeValue("secondaryGray.600", "white");

  const filterSelect = (filter: number) => {
    dispatch(actions.setFilterValue(filter));
  };

  const handleChange = (dates: any) => {
    const [start, end] = dates;
    dispatch(actions.setStartDate(start));
    dispatch(actions.setEndDate(end || ""));
    dispatch(actions.setFilterValue(-1));
  };

  return (
    <Flex my={5}>
      <Card>
        <Flex justify="flex-end" gap={4} flexWrap="wrap" >
      <Flex gap={2} flexWrap="wrap">
        {filters.map((filter) => (
          <Button
            key={filter.value}
            padding={5}
            variant={filterValue === filter.value ? "brand" : "outline"}
            onClick={() => filterSelect(filter.value)}
            color={filterValue === filter.value ? secondary : textColor}
            _hover={{
              color: "#fff",
              bg: "brand.500",
            }}
          >
            {t(filter.label)}
          </Button>
        ))}
      </Flex>

      <Box minW="230px">
        <DatePicker
          selected={startDate}
          onChange={handleChange}
          startDate={startDate}
          endDate={endDate}
          selectsRange
          maxDate={today}
          dateFormat="d MMM yyyy"
          popperPlacement="bottom-end"
          popperClassName="chakra-datepicker-popper"
          customInput={
            <Input
              readOnly
              bg={textColor}
              height="44px"
              border="0px"
              color="white"
              cursor="pointer"
              _hover={{ border: "none" }}
              _focus={{ border: "none", outline: "none", boxShadow: "none" }}
              _active={{ border: "none", outline: "none", boxShadow: "none" }}
            />
          }
        />
      </Box>
    </Flex>
      </Card>
    </Flex>
  );
};

export default Filter;
